import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58928b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding" }
const _hoisted_2 = {
  key: 0,
  class: "app-view__onboarding-warning app-view__onboarding-status"
}
const _hoisted_3 = { class: "app-view__onboarding-warning-message" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "m-0 mb-1" }
const _hoisted_6 = { class: "app-view__onboarding-warning-title" }
const _hoisted_7 = {
  key: 0,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"New Receiver\"", -1))
const _hoisted_9 = {
  key: 1,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ditto Receiver app", -1))
const _hoisted_11 = {
  key: 2,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "receiver type", -1))
const _hoisted_13 = {
  key: 3,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "receiver", -1))
const _hoisted_15 = {
  key: 4,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"New Room\"", -1))
const _hoisted_17 = {
  key: 5,
  class: "app-view__onboarding-warning-subtitle"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Create Room\"", -1))
const _hoisted_19 = { class: "onboarding__warning-message-footer" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "You must complete the setup process to use Ditto. Are you sure?", -1))
const _hoisted_22 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "app-view__onboarding-warning"
}
const _hoisted_25 = { class: "app-view__onboarding-warning-message primary-color" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-view__onboarding-warning-title" }, "You still need to finish setting up Ditto.", -1))
const _hoisted_27 = { class: "app-view__onboarding-warning-subtitle" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "4", -1))
const _hoisted_29 = { class: "onboarding__warning-message-footer" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "onboarding__target onboarding__target--top-left"
}, null, -1))
const _hoisted_31 = {
  key: 0,
  class: "el-overlay el-overlay--onboarding transition"
}
const _hoisted_32 = {
  key: 0,
  class: "el-dialog__container transition"
}
const _hoisted_33 = { class: "el-dialog onboarding-dialog white" }
const _hoisted_34 = { class: "el-dialog__header" }
const _hoisted_35 = { class: "flex-grow-1 d-flex flex-column" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "el-dialog__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "👋 Welcome to the Ditto setup tutorial.")
], -1))
const _hoisted_37 = { class: "onboarding__modal-content" }
const _hoisted_38 = { class: "flex-grow-1" }
const _hoisted_39 = {
  key: 0,
  class: "onboarding__modal-banners"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "m-0"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "share screens", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "digital signage", -1))
const _hoisted_46 = {
  key: 1,
  class: "m-0"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "receiver", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "room", -1))
const _hoisted_49 = {
  key: 2,
  class: "m-0"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "receiver", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "TV", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "projector", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "other screens", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Rooms"),
  /*#__PURE__*/_createTextVNode(" allow you to group and manage your "),
  /*#__PURE__*/_createElementVNode("strong", null, "receivers"),
  /*#__PURE__*/_createTextVNode(". Create and edit rooms here in the Account Portal.")
], -1))
const _hoisted_55 = { class: "callout callout--warning callout--no-max" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "m-0" }, [
  /*#__PURE__*/_createElementVNode("em", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Receivers"),
    /*#__PURE__*/_createTextVNode(" must be linked to a "),
    /*#__PURE__*/_createElementVNode("strong", null, "room"),
    /*#__PURE__*/_createTextVNode(" to be active.")
  ])
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "1. Receiver", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("An "),
  /*#__PURE__*/_createElementVNode("strong", null, "Apple TV HD/4K"),
  /*#__PURE__*/_createTextVNode(" or a "),
  /*#__PURE__*/_createElementVNode("strong", null, "Windows"),
  /*#__PURE__*/_createTextVNode(" device "),
  /*#__PURE__*/_createElementVNode("em", null, "(computer, stick, tablet, etc.)")
], -1))
const _hoisted_59 = { class: "m-0" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "2. Ditto Receiver App", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("You will need the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Receiver app"),
  /*#__PURE__*/_createTextVNode(" installed on your device to complete setup. Download the application for Apple TV and Windows "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/ditto/download",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "here"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Let's create a receiver", -1))
const _hoisted_63 = { class: "callout callout--no-max" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "\"Receivers\""),
  /*#__PURE__*/_createTextVNode(" to navigate to your receiver inventory.")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "\"Next\""),
  /*#__PURE__*/_createTextVNode(" to continue.")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Let's create a room", -1))
const _hoisted_67 = { class: "callout callout--no-max" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "\"Rooms\""),
  /*#__PURE__*/_createTextVNode(" to navigate to your room inventory.")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "\"Next\""),
  /*#__PURE__*/_createTextVNode(" to finish setup.")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Users can now navigate to "),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://connect.goditto.com/",
      class: "link",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "connect.goditto.com")
  ]),
  /*#__PURE__*/_createTextVNode(" or use the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ditto Connect App"),
  /*#__PURE__*/_createTextVNode(" to enter the room code displayed on the Ditto receiver and begin sharing screens.")
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("em", null, "Screen mirror Mac, Windows, iPhone, iPad, Chromebook and Android.")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-3" }, "Digital Signage", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Ditto makes it easy to connect with your audience at the right time and place with "),
  /*#__PURE__*/_createElementVNode("strong", null, "announcements, menus, wayfinding signs"),
  /*#__PURE__*/_createTextVNode(" and more.")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Emergency Alerts", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Custom Ditto digital signage emergency alerts can be used to share "),
  /*#__PURE__*/_createElementVNode("strong", null, "critical"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "time-sensitive information"),
  /*#__PURE__*/_createTextVNode(" on Ditto-enabled displays.")
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://form.jotform.com/220183376652052",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Share your feedback with us!")
], -1))
const _hoisted_77 = {
  key: 0,
  class: "onboarding__substep-progress mt-4"
}
const _hoisted_78 = { class: "el-dialog__footer" }
const _hoisted_79 = { class: "dialog-footer d-flex justify-content-between align-items-center" }
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, "You must complete the setup process to use Ditto. Are you sure?", -1))
const _hoisted_82 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_83 = { class: "d-flex align-items-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Navigate via the left navigation menu to continue.", -1))
const _hoisted_85 = { key: 0 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Next", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, {
      disabled: false,
      to: "body"
    }, [
      (_ctx.currentStep.banner && _ctx.userOnboardStatus && _ctx.userOnboardStatus.isOnboarding && _ctx.userOnboardStatus.showDialog)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "app-view__onboarding-warning-icon",
                alt: "Ditto Onboarding",
                src: require('../assets/images/onboarding.png')
              }, null, 8, _hoisted_4),
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.currentStep.category), 1),
                    _createTextVNode(" - " + _toDisplayString(_ctx.currentStep.name), 1)
                  ])
                ]),
                (_ctx.currentStep.guideStepId  == 'receiversClickNewReceiver')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createTextVNode("Click on "),
                      _hoisted_8,
                      _createTextVNode(" to create a new receiver.")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep.guideStepId  == 'receiversPairingCode')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createTextVNode("Enter your pairing code on your "),
                      _hoisted_10,
                      _createTextVNode(".")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep.guideStepId  == 'receiversReceiverType')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createTextVNode("Select the "),
                      _hoisted_12,
                      _createTextVNode(" you would like to add.")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep.guideStepId  == 'receiversReceiverInformation')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createTextVNode("Enter all the marked information for this "),
                      _hoisted_14,
                      _createTextVNode(".")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep.guideStepId  == 'roomsInventory')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _createTextVNode("Click "),
                      _hoisted_16,
                      _createTextVNode(" to navigate to the room creation page.")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentStep.guideStepId  == 'roomsCreation')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createTextVNode("Enter your room information and click "),
                      _hoisted_18,
                      _createTextVNode(".")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_el_button, {
              type: "text",
              class: "onboarding__status-help-link ms-auto",
              onClick: _ctx.clickSetupGuide
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "onboarding__status-help-link me-1",
                  fill: "#949494",
                  icon: _ctx.mdiHelpCircle
                }, null, 8, ["icon"]),
                _createTextVNode("Need help? Check out our setup guide")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_popover, {
                placement: "bottom-end",
                width: 500,
                onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onboarding.dontShowAgain = false)),
                "hide-after": 0,
                visible: _ctx.statusFinishLaterConfirmVisible,
                "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statusFinishLaterConfirmVisible) = $event))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "danger me-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Finish later ")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_20, [
                      _createVNode(_component_Icon, {
                        class: "me-2",
                        fill: "red",
                        icon: _ctx.mdiAlertCircleOutline
                      }, null, 8, ["icon"]),
                      _createTextVNode("Finish setup later?")
                    ]),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_el_checkbox, {
                      class: "me-auto d-flex align-items-center",
                      modelValue: _ctx.onboarding.dontShowAgain,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onboarding.dontShowAgain) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Don't show this again")
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      size: "medium",
                      type: "text",
                      class: "grey",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusFinishLaterConfirmVisible = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Continue setup")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "medium",
                      type: "danger",
                      onClick: _ctx.finishOnboardLaterConfirm
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Finish setup later")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              ((_ctx.onboarding.step > 1 || _ctx.onboarding.subStep != 1 && _ctx.currentStep.backStepJump > -1) && (_ctx.currentStep.guideStepId != 'receiversReceiverType' && _ctx.currentStep.guideStepId != 'receiversReceiverInformation'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_el_tooltip, {
                      content: "Go back",
                      "hide-after": 0,
                      placement: "bottom-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, { onClick: _ctx.previousStep }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Icon, {
                              class: "icon--small",
                              icon: _ctx.mdiChevronLeft
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, {
      disabled: !_ctx.onboarding.showDialog && _ctx.userOnboardStatus && _ctx.userOnboardStatus.isOnboarding,
      to: "#app"
    }, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_progress, {
                class: "app-view__onboarding-progress",
                color: "#00a887",
                type: "circle",
                "show-text": false,
                percentage: _ctx.onboarding.progress,
                width: 35
              }, null, 8, ["percentage"]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, [
                  _createTextVNode("Youre on step "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.onboarding.step), 1),
                  _createTextVNode(" of "),
                  _hoisted_28
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_el_button, {
                class: "glare",
                size: "small",
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onboarding.active = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_30,
                  _createTextVNode(" Finish ")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 8, ["disabled"])),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          (_ctx.currentStep.overlay && _ctx.userOnboardStatus && _ctx.userOnboardStatus.isOnboarding && _ctx.userOnboardStatus.showDialog)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                ((_ctx.currentStep.dialog) && _ctx.userOnboardStatus && _ctx.userOnboardStatus.isOnboarding && _ctx.userOnboardStatus.showDialog)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("section", _hoisted_33, [
                        _createElementVNode("aside", _hoisted_34, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", {
                              class: _normalizeClass({ active : _ctx.currentStep.category == 'Overview', finished: (_ctx.currentStep.category == 'Rooms' || _ctx.currentStep.category == 'Receivers' || _ctx.currentStep.category == 'Finish') })
                            }, [
                              _createTextVNode(" Overview "),
                              (_ctx.currentStep.category == 'Rooms' || _ctx.currentStep.category == 'Receivers' || _ctx.currentStep.category == 'Finish')
                                ? (_openBlock(), _createBlock(_component_Icon, {
                                    key: 0,
                                    class: "primary-color ms-2",
                                    icon: _ctx.mdiCheck
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass({ active : _ctx.currentStep.category == 'Receivers', finished: (_ctx.currentStep.category == 'Rooms' || _ctx.currentStep.category == 'Finish') })
                            }, [
                              _createTextVNode(" Receivers "),
                              (_ctx.currentStep.category == 'Rooms' || _ctx.currentStep.category == 'Finish')
                                ? (_openBlock(), _createBlock(_component_Icon, {
                                    key: 0,
                                    class: "primary-color ms-2",
                                    icon: _ctx.mdiCheck
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass({ active : _ctx.currentStep.category == 'Rooms', finished: _ctx.currentStep.category == 'Finish' })
                            }, [
                              _createTextVNode(" Rooms "),
                              (_ctx.currentStep.category == 'Finish')
                                ? (_openBlock(), _createBlock(_component_Icon, {
                                    key: 0,
                                    class: "primary-color ms-2",
                                    icon: _ctx.mdiCheck
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass({ active : _ctx.currentStep.category == 'Finish' })
                            }, " Finish Setup & More ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("main", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", null, [
                                (_ctx.currentStep.images.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentStep.images, (img, i) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          key: i,
                                          alt: "Ditto",
                                          src: require(`../assets/images/${ img }`)
                                        }, null, 8, _hoisted_40))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      class: "onboarding__modal-banner",
                                      alt: "Ditto",
                                      src: require(`../assets/images/${ _ctx.currentStep.images[0] }`)
                                    }, null, 8, _hoisted_41)),
                                _createElementVNode("h3", null, [
                                  _createTextVNode(_toDisplayString(_ctx.currentStep.category) + " ", 1),
                                  (_ctx.currentStep.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, " - " + _toDisplayString(_ctx.currentStep.name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  (_ctx.currentStep.guideStepId == 'overviewInitial')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                                        _createTextVNode("Ditto is the easiest way to "),
                                        _hoisted_44,
                                        _createTextVNode(" and display "),
                                        _hoisted_45,
                                        _createTextVNode(" in your organization.")
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'overviewGettingStarted')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                                        _createTextVNode("Before using Ditto, you must link a "),
                                        _hoisted_47,
                                        _createTextVNode(" with a "),
                                        _hoisted_48,
                                        _createTextVNode(" here in the Account Portal.")
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'overviewReceivers')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_49, [
                                        _createTextVNode("A "),
                                        _hoisted_50,
                                        _createTextVNode(" is what you screen mirror to and where digital signage is displayed. It's connected to your "),
                                        _hoisted_51,
                                        _createTextVNode(", "),
                                        _hoisted_52,
                                        _createTextVNode(" or "),
                                        _hoisted_53,
                                        _createTextVNode(".")
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'overviewRooms')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _hoisted_54,
                                        _createElementVNode("div", _hoisted_55, [
                                          _createVNode(_component_Icon, { icon: _ctx.mdiAlertCircle }, null, 8, ["icon"]),
                                          _hoisted_56
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'receiversYouNeedReceiver')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _hoisted_57,
                                        _hoisted_58,
                                        _createVNode(_component_el_popover, {
                                          placement: "right",
                                          width: 300
                                        }, {
                                          reference: _withCtx(() => [
                                            _createVNode(_component_el_button, {
                                              type: "text",
                                              class: "onboarding__status-help-link ms-auto",
                                              onClick: _ctx.clickNoDeviceHelp
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Icon, {
                                                  class: "me-1",
                                                  fill: "#949494",
                                                  icon: _ctx.mdiHelpCircle
                                                }, null, 8, ["icon"]),
                                                _createTextVNode("I don't have one of these devices.")
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", _hoisted_59, [
                                                _createTextVNode("You need one of the listed receiver devices to complete Ditto setup. Get complete details about our supported receivers "),
                                                _createElementVNode("a", {
                                                  href: "https://www.airsquirrels.com/ditto-portal/no-receiver",
                                                  target: "_blank",
                                                  rel: "noreferrer noopener",
                                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickReceiverDetails && _ctx.clickReceiverDetails(...args)))
                                                }, "here"),
                                                _createTextVNode(".")
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'receiversYouNeedApp')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _hoisted_60,
                                        _hoisted_61
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'receiversClickReceivers')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _hoisted_62,
                                        _createElementVNode("div", _hoisted_63, [
                                          _createVNode(_component_Icon, { icon: _ctx.mdiCursorDefault }, null, 8, ["icon"]),
                                          _hoisted_64
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'receiversReceiverCreated')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                        _createElementVNode("p", null, [
                                          _createTextVNode("Nice! "),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.createdReceiverName), 1),
                                          _createTextVNode(" was successfully created.")
                                        ]),
                                        _hoisted_65
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'roomsClickRooms')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                        _hoisted_66,
                                        _createElementVNode("div", _hoisted_67, [
                                          _createVNode(_component_Icon, { icon: _ctx.mdiCursorDefault }, null, 8, ["icon"]),
                                          _hoisted_68
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'roomCreationSuccessful')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                        _createElementVNode("p", null, [
                                          _createTextVNode("Nice! "),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.createdRoomName), 1),
                                          _createTextVNode(" was successfully created.")
                                        ]),
                                        _hoisted_69
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'finishDittoConnect')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                        _hoisted_70,
                                        _hoisted_71,
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          plain: "",
                                          onClick: _ctx.onDownloadDittoConnect
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Download Ditto Connect")
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.currentStep.guideStepId == 'finishOtherFeatures')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                        _hoisted_72,
                                        _hoisted_73,
                                        _createElementVNode("a", {
                                          href: "https://help.airsquirrels.com/ditto/293-ditto-digital-signage-overview",
                                          target: "_blank",
                                          rel: "noreferrer noopener",
                                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSignage && _ctx.onSignage(...args)))
                                        }, "Learn more about getting started with Ditto digital signage."),
                                        _hoisted_74,
                                        _hoisted_75,
                                        _createElementVNode("a", {
                                          href: "https://help.airsquirrels.com/ditto/364-custom-manual-ditto-digital-signage-alerts",
                                          target: "_blank",
                                          rel: "noreferrer noopener",
                                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAlerts && _ctx.onAlerts(...args)))
                                        }, "Learn more about getting started with Ditto emergency alerts."),
                                        _hoisted_76
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (_ctx.currentStep.number)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMaxSteps, (step) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: step,
                                      class: _normalizeClass(["onboarding__substep-progress-step", { active : _ctx.currentStep.number == step }])
                                    }, null, 2))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("footer", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createVNode(_component_el_popover, {
                                placement: "bottom-start",
                                width: 500,
                                onHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onboarding.dontShowAgain = false)),
                                "hide-after": 0,
                                visible: _ctx.finishLaterConfirmVisible,
                                "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.finishLaterConfirmVisible) = $event))
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "text",
                                    class: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Finish later ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("h3", _hoisted_80, [
                                      _createVNode(_component_Icon, {
                                        class: "me-2",
                                        fill: "red",
                                        icon: _ctx.mdiAlertCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createTextVNode("Finish setup later?")
                                    ]),
                                    _hoisted_81
                                  ]),
                                  _createElementVNode("div", _hoisted_82, [
                                    _createVNode(_component_el_checkbox, {
                                      class: "me-auto d-flex align-items-center",
                                      modelValue: _ctx.onboarding.dontShowAgain,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.onboarding.dontShowAgain) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Don't show this again")
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_el_button, {
                                      size: "medium",
                                      type: "text",
                                      class: "grey",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.finishLaterConfirmVisible = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Continue setup")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      size: "medium",
                                      type: "danger",
                                      onClick: _ctx.finishOnboardLaterConfirm
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Finish setup later")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["visible"]),
                              _createElementVNode("div", _hoisted_83, [
                                (_ctx.onboarding.step > 1 || _ctx.onboarding.subStep != 1 && _ctx.currentStep.backStepJump > -1)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      onClick: _ctx.previousStep
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Icon, {
                                          class: "icon--small",
                                          icon: _ctx.mdiChevronLeft
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_tooltip, {
                                  placement: "top-end",
                                  effect: "dark",
                                  disabled: _ctx.currentStep.guideStepId  != 'receiversClickReceivers' && _ctx.currentStep.guideStepId  != 'roomsClickRooms'
                                }, {
                                  content: _withCtx(() => [
                                    _hoisted_84
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      class: _normalizeClass({ 'is-disabled' : _ctx.currentStep.guideStepId  == 'receiversClickReceivers' || _ctx.currentStep.guideStepId  == 'roomsClickRooms' }),
                                      type: "primary",
                                      plain: _ctx.currentStep.guideStepId  != 'finishOtherFeatures' && _ctx.currentStep.guideStepId  != 'roomCreationSuccessful',
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.nextStepClickHandler($event)))
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.currentStep.guideStepId  == 'finishOtherFeatures')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, "Finish"))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _hoisted_86,
                                              _createVNode(_component_Icon, {
                                                class: "icon--small ms-1",
                                                icon: _ctx.mdiChevronRight
                                              }, null, 8, ["icon"])
                                            ], 64))
                                      ]),
                                      _: 1
                                    }, 8, ["class", "plain"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_el_button, {
                        type: "text",
                        class: "get-help-link",
                        onClick: _ctx.clickSetupGuide
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, { icon: _ctx.mdiHelpCircle }, null, 8, ["icon"]),
                          _createTextVNode("Need help? Check out our setup guide")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}